import getInsertLinkViewState from '../selectors/getInsertLinkViewState';

export function isInsertLinkPending(linkId: string): boolean {
    const viewState = getInsertLinkViewState(linkId);
    if (viewState) {
        return viewState.isRetrievingSharingLink;
    }

    return false;
}
